export { pageBackgroundColor as pageBgColor } from "@dexteel/mesf-core";

export const primaryColor = "#3f51b5";
export const backgroundColor = "#eef6fbff";
export const masterDetailsMinHeight = "calc(100vh - 64px)";
export const autocompleteOptionColor = "#f4978e4f";
